<template>
  <div class="row">
    <b-form-group
        id="formgroup-firstField"
        :label="$t('trigger.form.fields.condicao.fields.firstField.label')"
        :description="this.showDescription ? $t('trigger.form.fields.condicao.fields.firstField.description') : ''"
        label-for="trigger-firstField"
        class="col-md-4"
        required
    >
      <b-form-select v-model="form.firstField" :options="DB_fields" v-on:change="onChangeField"/>
    </b-form-group>
    <b-form-group
        id="formgroup-rule"
        :label="$t('trigger.form.fields.condicao.fields.rule.label')"
        :description="this.showDescription ? $t('trigger.form.fields.condicao.fields.rule.description') : ''"
        label-for="name-rule"
        class="col-md-4"
        required
    >
      <b-form-select v-model="form.regra" :options="rules" v-on:change="onChangeRule"/>
    </b-form-group>
    <b-form-group
        v-if="showSecondField"
        id="formgroup-secondField"
        :label="$t('trigger.form.fields.condicao.fields.secondField.label')"
        :description="this.showDescription ? $t('trigger.form.fields.condicao.fields.secondField.description') : ''"
        label-for="trigger-secondField"
        :class="needTwoFieldsClass"
    >
      <b-form-input v-model="form.secondField" v-on:change="onChangeSecondField"/>
    </b-form-group>
    <b-form-group
        v-if="needTwoFieldsBoolean"
        id="formgroup-thirdField"
        :label="$t('trigger.form.fields.condicao.fields.thirdField.label')"
        :description="this.showDescription ? $t('trigger.form.fields.condicao.fields.thirdField.description') : ''"
        label-for="trigger-thirdField"
        :class="needTwoFieldsClass"
    >
      <b-form-input v-model="form.thirdField" v-on:change="onChangeThirdField"/>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "Condition",
  props: {
    form: {
      index: {
        Number,
        default: 0
      },
      firstField: {
        String,
        default: null
      },
      regra: {
        String,
        default: null
      },
      secondField: {
        String,
        default: null
      },
      thirdField: {
        String,
        default: null
      }
    },
    showDescription: {
      Boolean,
      default: true
    }
  },
  data() {
    return {
      DB_fields: [
        {value: 'exam_code', text: this.$t('trigger.form.fields.condicao.DB_fields.exam_code')},
        {value: 'method_code', text: this.$t('trigger.form.fields.condicao.DB_fields.method_code')},
        {value: 'specimen_code', text: this.$t('trigger.form.fields.condicao.DB_fields.specimen_code')},
        {value: 'value_quantity_value', text: this.$t('trigger.form.fields.condicao.DB_fields.value_quantity_value')},
        {value: 'reference_range_text', text: this.$t('trigger.form.fields.condicao.DB_fields.reference_range_text')},
        {
          value: 'reference_range_structured',
          text: this.$t('trigger.form.fields.condicao.DB_fields.reference_range_structured')
        },
        {value: 'parent_exam_code', text: this.$t('trigger.form.fields.condicao.DB_fields.parent_exam_code')}
      ],
      rules: [
        {value: 'IS NULL', text: this.$t('trigger.form.fields.condicao.rules.isNull'), requireSecondField: false},
        {
          value: 'IS NOT NULL',
          text: this.$t('trigger.form.fields.condicao.rules.isNotNull'),
          requireSecondField: false
        },
        {value: '>', text: this.$t('trigger.form.fields.condicao.rules.bigger'), requireSecondField: true},
        {value: '>=', text: this.$t('trigger.form.fields.condicao.rules.biggerOrEqual'), requireSecondField: true},
        {value: '<', text: this.$t('trigger.form.fields.condicao.rules.less'), requireSecondField: true},
        {value: '<=', text: this.$t('trigger.form.fields.condicao.rules.lessOrEqual'), requireSecondField: true},
        {value: '==', text: this.$t('trigger.form.fields.condicao.rules.equal'), requireSecondField: true},
        {value: '!=', text: this.$t('trigger.form.fields.condicao.rules.different'), requireSecondField: true},
        {value: 'BETWEEN', text: this.$t('trigger.form.fields.condicao.rules.between'), requireSecondField: true},
        {value: 'NOT BETWEEN', text: this.$t('trigger.form.fields.condicao.rules.notBetween'), requireSecondField: true}
      ],
      needTwoFieldsClass: 'col-md-4',
      needTwoFieldsBoolean: false,
      showSecondField: true
    }
  },
  methods: {
    onChangeRule() {
      if (this.form.regra === 'NOT BETWEEN' || this.form.regra === 'BETWEEN') {
        this.needTwoFieldsClass = 'col-md-2'
        this.needTwoFieldsBoolean = true
        return
      }
      this.needTwoFieldsClass = 'col-md-4'
      this.needTwoFieldsBoolean = false

      this.$emit('change', this.form)
    },
    onChangeField() {
      this.$emit('change', this.form)
    },
    onChangeSecondField() {
      this.$emit('change', this.form)
    },
    onChangeThirdField() {
      this.$emit('change', this.form)
    },
  },
  mounted() {
    this.onChangeRule()
  }
}
</script>

<style scoped>

</style>
